import { AvatarBox } from "@/components/logo";
import { Button, Heading, Text } from "@medusajs/ui";
import { Link } from "@tanstack/react-router";

/**
 * The router-wide fallback for an unmatched URL that no app shell handles
 * (`defaultNotFoundComponent`). Deliberately self-contained: it assumes no
 * session, profile or query data, because it can render where none exists. It
 * mirrors the login page's standalone look. A signed-in salon normally sees
 * `NotFoundPage` inside the shell instead.
 */
export function StandaloneNotFound() {
  return (
    <div className="bg-ui-bg-subtle flex min-h-dvh w-dvw items-center justify-center">
      <main className="m-4 flex w-full max-w-[280px] flex-col items-center">
        <AvatarBox checked={false} />
        <div className="mb-6 flex flex-col items-center">
          <Heading level="h1">We couldn&apos;t find that page</Heading>
          <Text size="small" className="text-ui-fg-subtle text-center">
            The link may be out of date or mistyped.
          </Text>
        </div>
        <Button asChild className="w-full">
          <Link to="/">Go to SalonStocker</Link>
        </Button>
      </main>
    </div>
  );
}
